import { ApplicationRoutes, DocsRoutes } from 'common/constants';
import { importMDX } from 'mdx.macro';
import React, { lazy } from 'react';
import { Redirect, Route } from 'react-router';

import DocsView from './DocsView';

const About = lazy(() => importMDX('../../assets/docs/About.mdx'));
const WhatsNovel = lazy(() => importMDX('../../assets/docs/WhatsNovel.mdx'));
const UserDocs = lazy(() => importMDX('../../assets/docs/UserDocs.mdx'));
const FragnetGeneration = lazy(() => importMDX('../../assets/docs/FragnetGeneration.mdx'));

interface Path {
  path: string;
  content: React.ReactNode;
}

const DocsRoute = () => {
  const routes: Path[] = [
    {
      path: DocsRoutes.About.toString(),
      content: <About />,
    },
    {
      path: DocsRoutes.WhatsNovel.toString(),
      content: <WhatsNovel />,
    },
    {
      path: DocsRoutes.UserDocs.toString(),
      content: <UserDocs />,
    },
    {
      path: DocsRoutes.FragnetGeneration.toString(),
      content: <FragnetGeneration />,
    },
  ];
  // Redirect docs' base route to the first page
  routes.unshift({ path: ApplicationRoutes.Docs, content: <Redirect to={routes[0].path} /> });
  return (
    <>
      {routes.map(({ path, content }, index) => (
        <Route
          path={path}
          key={`${path}-${index}`}
          exact
          render={() => <DocsView>{content}</DocsView>}
        />
      ))}
    </>
  );
};

export default DocsRoute;
